import { Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE } from "../../lib/data";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.04 21.785h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.889-9.884 2.641 0 5.124 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.886 9.884zm8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.49-8.413z"/>
  </svg>
);

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A362D] text-[#F7F5F0] pt-24 pb-10"
    >
      <div className="max-w-[100rem] mx-auto px-6 sm:px-10 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <img
            src={SITE.logo}
            alt="Amarja Hills"
            className="h-14 w-auto logo-on-dark"
          />
          <p className="mt-6 max-w-md text-[#F7F5F0]/75 leading-relaxed">
            An ultra-luxury 500-acre estate of villa plots and ready-to-move
            villas by Pawna Lake, Lonavala. Home of{" "}
            <strong className="text-[#E2CFA1] font-semibold">The Farmhouse Project</strong>.
            Developed by Nanak Properties Pvt Ltd.
          </p>

          <div className="mt-8 flex items-center gap-5">
            <a
              data-testid="footer-instagram"
              href={SITE.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="text-[#F7F5F0] hover:text-[#E2CFA1] transition-colors"
            >
              <Instagram className="w-5 h-5" strokeWidth={1.6} />
            </a>
            <a
              data-testid="footer-whatsapp"
              href={`https://wa.me/${SITE.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="text-[#F7F5F0] hover:text-[#E2CFA1] transition-colors"
            >
              <WhatsAppIcon className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <p className="text-[11px] tracking-[0.28em] uppercase text-[#E2CFA1] font-semibold mb-5">
            Enquire to Buy
          </p>
          <a
            data-testid="footer-phone"
            href={`tel:${SITE.telHref}`}
            className="font-serif-display text-3xl text-[#F7F5F0] hover:text-[#E2CFA1] transition-colors font-light"
          >
            {SITE.phone}
          </a>
          <a
            data-testid="footer-email"
            href={`mailto:${SITE.email}`}
            className="block mt-4 text-[#F7F5F0]/80 hover:text-[#F7F5F0] transition-colors"
          >
            {SITE.email}
          </a>
        </div>

        <div className="lg:col-span-4">
          <p className="text-[11px] tracking-[0.28em] uppercase text-[#E2CFA1] font-semibold mb-5">
            Office
          </p>
          <p className="text-[#F7F5F0]/80 leading-relaxed text-sm">
            {SITE.address}
          </p>
        </div>
      </div>

      <div className="max-w-[100rem] mx-auto px-6 sm:px-10 lg:px-16 mt-20 pt-8 border-t border-[#F7F5F0]/15 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-[#F7F5F0]/60">
        <p>
          © {new Date().getFullYear()} Amarja Hills · Nanak Properties Pvt Ltd
          · All rights reserved.
        </p>
        <div className="flex flex-col md:flex-row md:items-center md:gap-6 gap-2">
          <Link
            data-testid="footer-privacy-link"
            to="/privacy-policy"
            className="text-[#F7F5F0]/70 hover:text-[#E2CFA1] transition-colors"
          >
            Privacy Policy
          </Link>
          <a
            data-testid="footer-rent-link"
            href={SITE.experienceUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#F7F5F0]/70 hover:text-[#E2CFA1] transition-colors"
          >
            Looking to rent? Visit amarjaexperience.com →
          </a>
          <p className="tracking-[0.22em] uppercase">
            Plots &amp; Villas · For Sale
          </p>
        </div>
      </div>
    </footer>
  );
}
